import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { useAddNoteModal } from '../context/AddNoteModalContext';

const AddNoteModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddNoteModal();

  const butonDisabled =
    !data.text ||
    !data.date ||
    (data.modalActionType === actionTypes.EDIT && !data.hasBeenModified);

  const buttonLabel =
    data.modalActionType === actionTypes.EDIT
      ? t('UpdateAnnotation')
      : t('AddAnnotation');

  return (
    <Modal.Footer>
      <Button onClick={actions.handleSaveNote} disabled={butonDisabled} lgSize>
        {buttonLabel}
      </Button>
    </Modal.Footer>
  );
};

export default AddNoteModalFooter;
